// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"fd8c1fbe","305":"8ce388ce","683":"34ea129f"}[chunkId] + ".chunk.js";
};